export default __webpack_public_path__ + "static/media/Rays.f15ed9a1.png";